
export const NavbarData_login =[
    {
        title : "Register",
        path:"/register",
    },
    {
        title : "Login",
        path:"/",
    },
]